import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UigBannerCarouselComponent } from './uig-banner-carousel.component';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { MediaModule, PageComponentModule } from '@spartacus/storefront';
import { UigCarouselModule } from '../uig-carousel/uig-carousel.module';

@NgModule({
  declarations: [UigBannerCarouselComponent],
  imports: [
    CommonModule,
    PageComponentModule,
    MediaModule,
    UigCarouselModule
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        RotatingImagesComponent: {
          component: UigBannerCarouselComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class UigBannerCarouselModule { }
